<template>
  <div class="main-wrapper" >

    <div class="main-scroll">
      <nav-com></nav-com>
      <edit-com></edit-com>
      <foot-com class="foots"></foot-com>
    </div>
    <bottom-backtop></bottom-backtop>

  </div>
</template>

<script>
import NavCom from '../common/navs';
import FootCom from '../common/foots';
import editCom from './editPw';
import BottomBacktop from '../common/BottomBacktop';



export default {
  name: 'editPw',
  components: {
    NavCom,
    FootCom,
    editCom,
    BottomBacktop
  },
}
</script>

<style lang="scss" scoped></style>
